require('../modules/es.parse-float');
var path = require('../internals/path');

module.exports = path.parseFloat;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/es/parse-float.js
// module id = 241
// module chunks = 0